module.exports = __webpack_public_path__ + "7c7cd8aac05e0f8431894af9b7b3de86.svg";